<template>
  <div class="tab-inner">
    <ul
      class="tab-link-box"
      ref="tabBox"
      :class="tabItems.length > 2 ? 'many-tabs' : 'few-tabs'"
    >
      <li
        v-for="(tab, idx) in tabItems"
        :key="tab.key"
        @click="setTabSelect(tab, idx)"
        class="tab-link"
        :class="{ active: tab.isActive }"
        :ref="(el) => (tabRefs[idx] = el)"
      >
        {{ tab.value }}
      </li>
      <div
        v-if="tabItems.length > 2"
        class="tab-underline"
        :style="{
          width: underlineWidth + 'px',
          left: underlineLeft + 'px',
        }"
      />
    </ul>
  </div>
</template>

<script setup>
import {
  ref,
  computed,
  onMounted,
  nextTick,
  defineProps,
  defineEmits,
} from "vue";
import { useStore } from "vuex";

const props = defineProps({
  tabItems: Array,
});

const tabItems = computed(() => props.tabItems);
const underlineLeft = ref(0);
const underlineBottom = ref(0);
const underlineWidth = ref(0);
const tabRefs = ref([]);
const emit = defineEmits(["tabSelectHandler"]);
const store = useStore();
const isMobile = computed(() => store.state.account.isMobile);

function setTabSelect(tab, idx) {
  emit("tabSelectHandler", tab.key);
  if (tab?.isBeta) return;
  updateUnderline(idx);
}

// const updateUnderline = (index) => {
//   nextTick(() => {
//     const tabEl = tabRefs[index];
//     if (tabEl) {
//       underlineLeft.value = tabEl.offsetLeft;
//       underlineBottom.value = tabEl.offsetTop + tabEl.offsetHeight - 1;
//       underlineWidth.value = tabEl.offsetWidth;
//     }
//   });
// };

const updateUnderline = (index) => {
  nextTick(() => {
    const tabEl = tabRefs.value[index]; // [수정] ref.value로 접근
    if (tabEl) {
      underlineLeft.value = tabEl.offsetLeft;
      underlineWidth.value = tabEl.offsetWidth;

      const tabBox = tabEl.parentElement;

      const tabBoxEl = tabBox.value;
      if (tabBoxEl && tabItems.value.length > 2) {
        tabBoxEl.scrollTo({
          left:
            tabEl.offsetLeft - tabBoxEl.offsetWidth / 2 + tabEl.offsetWidth / 2,
          behavior: "smooth",
        });
      }
    }
  });
};
onMounted(() => {
  const activeIndex = tabItems.value.findIndex((tab) => tab.isActive);
  updateUnderline(activeIndex >= 0 ? activeIndex : 0);
});
</script>

<style lang="scss" scoped>
@use "@/assets/scss/components/common/tab.scss";
</style>
